import React, { useState } from "react";
import { Box, Text, Badge, Button, Code, Collapse } from "@chakra-ui/react";


const ScriptStatusBox = ({ scriptStatus, settingStatus ,loading}) => {
    const [showDetails, setShowDetails] = useState(false);

    const toggleDetails = () => setShowDetails(!showDetails);
    console.log("ScriptStatusBox ", scriptStatus);
    console.log("ScriptStatusBox --> ",settingStatus);
    
    
    return (
        <Box borderWidth={1} borderRadius="md" p={4}>
            {/* Script Status and Active Games */}
            <Text>
                Status:{" "}
                <Badge colorScheme={scriptStatus?.isRunning ? "green" : "red"}>
                    {scriptStatus?.isRunning ? "Running" : "Stopped"}
                </Badge>
            </Text>
            <Text>AutoReload Draw: {scriptStatus?.autoReloadDraw || false}</Text>
            <Text>Active Games: {scriptStatus?.activeGames || 0}</Text>

            {/* Toggle Button */}
            <Button
                size="sm"
                mt={4}
                onClick={toggleDetails}
                colorScheme="blue"
                variant="outline"
            >
                {showDetails ? "Hide Details" : "Show More"}
            </Button>

            {/* Collapsible Section */}
            <Collapse in={showDetails} animateOpacity>
                <Box mt={4} p={2} borderWidth={1} borderRadius="md" bg="gray.50">
                    <Text>Active: {settingStatus?.is_active ? "Yes" : "No"}</Text>
                    <Text>Game Backup: {settingStatus?.gameBackup || "N/A"}</Text>
                    <Text>Game Upload: {settingStatus?.gameUpload || "N/A"}</Text>
                    <Text>Auto Start: {settingStatus?.autoStart ? "Enabled" : "Disabled"}</Text>
                    <Text>Re-Upload: {settingStatus?.reUpload ? "Yes" : "No"}</Text>
                    <Text>Last Backup  : {settingStatus?.lastBackupDiffInDays < 0 ? settingStatus.lastBackupDiffInDays + "Days old" : "Today"}</Text>
                    <Text>Last Game Upload: {settingStatus?.lastGameUpload < 0 ? settingStatus.lastGameUpload + "Days old" : "Today"} </Text>
                    <Code p={2} bg="gray.100" borderRadius="md" overflow="auto">
                        <pre>{JSON.stringify(settingStatus, null, 2)}</pre>
                    </Code>
                    loading: <Text>{loading}</Text>
                </Box>
            </Collapse>
        </Box>
    );
};

export default ScriptStatusBox;

/*
<Box borderWidth={1} borderRadius="md" p={2}>
                          <Text>
                              Status: {' '}
                              <Badge colorScheme={scriptStatus?.isRunning ? "green" : "red"}>
                                  {scriptStatus?.isRunning ? "Running" : "Stopped"}
                              </Badge>
                          </Text>
                          <Text>Active Games: {scriptStatus?.activeGames || 0}</Text>
                      </Box>
*/